import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './config/firebase-config';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css'; 
import * as Sentry from "@sentry/browser";

if (!window.location.host.startsWith('localhost')) {
  // 로컬이 아닐 때만 에러 전송
  Sentry.init({ dsn: "https://8883a9b2c8ff4b9e9653574aecff3aa0@logging.playballfantasy.com/1" });
}

// Check for new version and refresh
if (process.env.NODE_ENV !== 'development') {
  const checkVersion = async () => {
    try {
      // Add a cache-busting query parameter to the fetch request
      const response = await fetch('/index.html?t=' + new Date().getTime());
      if (!response.ok) {
        console.error('Failed to fetch index.html:', response.statusText);
        return;
      }
      const newHtml = await response.text();

      // Find the script tag in the new HTML
      const newDoc = new DOMParser().parseFromString(newHtml, 'text/html');
      const newScriptSrc = newDoc.querySelector('script[src*="/static/js/main."]')?.getAttribute('src');

      // Find the script tag in the current document
      const currentScriptSrc = document.querySelector('script[src*="/static/js/main."]')?.getAttribute('src');

      if (newScriptSrc && currentScriptSrc && newScriptSrc !== currentScriptSrc) {
        // If the script src is different, a new version is available.
        window.location.reload();
      }
    } catch (error) {
      console.error('Error checking for new version:', error);
    }
  };

  // Check every hour
  setInterval(checkVersion, 1000 * 60 * 60);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
